export const idConverter = (data = "") => {
  return data.replaceAll(" ", "-");
};
